export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9808.461a2b6c.jpg";